import { useEffect, useState } from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';
import { DeepPartial, Tokens } from '@vk-hr-tek/ui/Theme';

import { AppService } from '@app/services';

export const useCustomTheme = () => {
  const appService = useInject(AppService);

  const [customTheme, setCustomTheme] = useState<DeepPartial<Tokens>>(
    {} as Tokens,
  );

  useEffect(() => {
    appService
      .getDesignTokens()
      .then((tokens) => setCustomTheme(tokens))
      .catch(() => {});
  }, [appService]);

  return {
    ...(customTheme.name ? { name: customTheme.name } : {}),
    ...(customTheme.typography?.variant
      ? { typography: { variant: customTheme.typography.variant } }
      : {}),
    ...(customTheme.density ? { density: customTheme.density } : {}),
    ...(customTheme.radius ? { radius: customTheme.radius } : {}),
    ...(customTheme.colors ? { colors: customTheme.colors } : {}),
  } as DeepPartial<Tokens>;
};
